import { useAuth } from 'contexts/AuthContext'
import { useRouter } from 'next/router'
import { useForgotPasswordPage } from '../ForgotPasswordPage/logic'
import * as EmailValidator from 'email-validator'
import { Wrapper } from 'styles/styleSystem/wrapper'
import { Input } from 'components/Input'
import { INPUT_VARIANTS } from 'components/Input/types'
import { Tooltip } from 'antd'
import { Button, BUTTON_VARIANTS } from 'components/Button'
import { Text } from 'components/Text'
import { Bubble } from 'components/Bubble'

export const ForgotPasswordForm = ({ setSection = null }) => {
  const { forgotPassword } = useAuth()
  const {
    email,
    error,
    status,
    loading,
    handleSendForgotPassword,
    handleEmailChange,
  } = useForgotPasswordPage(forgotPassword)
  const sendDisabled = !EmailValidator.validate(email)
  const router = useRouter()

  const renderStatusBubble = () => {
    if (status) {
      return <Bubble type="success" text={status} />
    }

    if (error) {
      return <Bubble type="error" text={error} />
    }
  }

  return (
    <form onSubmit={handleSendForgotPassword}>
      <Wrapper spacing={20}>
        {status && <Wrapper mb={3}>{renderStatusBubble()}</Wrapper>}
        <Input
          alt="email"
          variant={INPUT_VARIANTS.label}
          value={email}
          placeholder="user@gmail.com"
          onChange={handleEmailChange}
          label="Email"
        />
      </Wrapper>
      <Wrapper mt={40}>
        <Tooltip title={sendDisabled ? 'Please enter a valid email' : null}>
          <div>
            <Button
              size="lg"
              fullWidth
              variant={BUTTON_VARIANTS.primary}
              label="Send"
              disabled={sendDisabled || loading}
              loading={loading}
            />
          </div>
        </Tooltip>
      </Wrapper>
      <Wrapper
        mt={30}
        spacing={5}
        display="flex"
        alignItems="center"
        justifyContent="center"
        horizontal
      >
        <Text size="md" weight="light" color="secondary">
          Don&#39;t have an account?
        </Text>
        <Text
          hover
          weight="base"
          onClick={() =>
            setSection ? setSection('signup') : router.push('/join')
          }
        >
          Join Fintros.
        </Text>
      </Wrapper>
      <Wrapper
        mt={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text
          hover
          size="md"
          weight="light"
          color="secondary"
          onClick={() =>
            setSection ? setSection('login') : router.push('/login')
          }
        >
          Login
        </Text>
      </Wrapper>
      {error && <Text color="red">{error}</Text>}
    </form>
  )
}
